module.exports = __webpack_public_path__ + "img/565403bbc03234377a081f3c6ed4a544.png";